/* eslint-disable react/jsx-closing-tag-location */
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import styled from 'styled-components';
import utils from '../../../../lib/utils';
import { font, color } from '../../../../config/css';

const DocumentBrowseCardPriceWrapper = styled.div.attrs({
  className: 'document-browse-card__price',
})`
  .price-value {
    font: ${font('lg', 'lg', 'pnb')};
    color: ${color('tomato')};
  }

  .price-value--original {
    color: ${color('regentGray')};
    text-decoration: line-through;
  }
`;

class DocumentBrowseCardPrice extends Component {
  render() {
    const { currentPrice, previousPrice } = this.props;
    return (
      <DocumentBrowseCardPriceWrapper>
        <span
          aria-label={`current price ${utils.formatInDollars(currentPrice)}`}
          className="price-value"
        >
          {utils.formatInDollars(currentPrice)}{' '}
        </span>
        {previousPrice ? (
          <span
            aria-label={`previous price ${utils.formatInDollars(
              previousPrice,
            )}`}
            className="price-value price-value--original"
          >
            {utils.formatInDollars(previousPrice)}
          </span>
        ) : null}
      </DocumentBrowseCardPriceWrapper>
    );
  }
}

DocumentBrowseCardPrice.propTypes = {
  currentPrice: PropTypes.number.isRequired,
  previousPrice: PropTypes.number,
};

DocumentBrowseCardPrice.defaultProps = {
  previousPrice: null,
};

export default DocumentBrowseCardPrice;
